import { withChildren } from '@builder.io/react';
import { withTracking } from '../../../observability';
import {
  CtaGoal,
  CtaName,
  SectionName,
} from '../../../observability/tracking/events';
import { createBuilderModule } from '../../../register-builder/builder-module';
import { imgElement } from '../../../register-builder/element-factories';
import { HeroStandard } from './HeroStandard';
import { COLOR_KEYS } from '../../../constants';

export default createBuilderModule(
  withChildren(
    withTracking(HeroStandard, { sectionName: SectionName.HeroStandard }),
  ),
  {
    name: 'HeroStandard',
    image: 'https://cdn.zappy.app/b131ef7a291b8a1a46b47e432e98dd4b.png',
    hideFromInsertMenu: true,
    defaultChildren: [
      imgElement({
        src: 'https://cdn.zappy.app/33e321b4fe5eabfa3accc17810aec145.png',
      }),
    ],
    inputs: [
      {
        name: 'heading',
        type: 'string',
        defaultValue: 'Example Heading',
        required: true,
      },
      {
        name: 'description',
        type: 'string',
        defaultValue: 'Example description...',
        required: true,
      },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.lava60,
          COLOR_KEYS.ocean40,
          COLOR_KEYS.sun60,
          COLOR_KEYS.white,
          // V5 colors
          COLOR_KEYS.moss,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.neutral800,
          COLOR_KEYS.night,
          COLOR_KEYS.zapier,
        ],
        defaultValue: COLOR_KEYS.neutral100,
        required: true,
      },
      {
        name: 'ctaText',
        type: 'string',
        defaultValue: 'Sign up',
      },
      {
        name: 'ctaName',
        type: 'string',
        enum: Object.values(CtaName),
        defaultValue: CtaName.signup,
        helperText:
          'For data tracking: Collaborate with data team on which value should be tracked for this CTA.',
      },
      {
        name: 'ctaGoal',
        type: 'string',
        enum: Object.values(CtaGoal),
        defaultValue: CtaGoal.signup,
        helperText:
          'For data tracking: Collaborate with data team on which value should be tracked for this CTA.',
      },
      {
        name: 'ctaHref',
        type: 'string',
        defaultValue: '#',
      },
      {
        name: 'ctaDisclaimer',
        type: 'richText',
        defaultValue:
          'By signing up, you agree to Zapier’s <a href="https://zapier.com/legal" target="_blank">Terms of Service</a> and <a href="https://zapier.com/privacy" target="_blank">Privacy Policy</a>',
      },
    ],
  },
);
